import React, { useState, useEffect } from 'react';

import type { SanityGlobalProduct } from '@rsc/models/gatsby-graphql-types';
import ProductOptions from '@rsc/ui-components/tailwind/ProductOptions';

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@rsc/ui-components/shadcn/Drawer';
import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@rsc/ui-components/shadcn/Dialog';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

interface Props {
  product: SanityGlobalProduct;
  isOpen: boolean;
  onClose: (...args: unknown[]) => unknown;
}

export default function ProductModal({
  product,
  isOpen,
  onClose,
}: Readonly<Props>) {
  const { tt } = useUiComponentsInternationalContext();
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleClose = e => {
    e.preventDefault();
    onClose();
  };

  if (width < 768) {
    return (
      <Drawer open={isOpen} onClose={() => onClose(true)}>
        <DrawerContent style={{ zIndex: 1500 }}>
          <DrawerHeader>
            <DrawerTitle>{product.store?.title}</DrawerTitle>
            <DrawerClose onClick={handleClose}>
              <span className="sr-only">
                {tt(s => s.productModalComponent.closeButton)}
              </span>
            </DrawerClose>
          </DrawerHeader>
          <DrawerDescription>
            <ProductOptions showPrice onClose={onClose} formClasses="mt-0" />
          </DrawerDescription>
        </DrawerContent>
      </Drawer>
    );
  }
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent closeBool={false}>
        <DialogClose
          className="absolute top-6 flex items-center justify-center"
          onClick={handleClose}
        />
        <DialogHeader className="mr-6">
          <DialogTitle>{product.store?.title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <ProductOptions showPrice onClose={onClose} formClasses="mt-0" />
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
